import type { Account } from "../types/management-auth";

export const isRootAccount = (accountId: string | Account | undefined) => {
    if (typeof accountId === "string") {
        return accountId.endsWith("00000000");
    }
    if (
        typeof accountId === "object" &&
        "account_id" in accountId &&
        accountId.account_id
    ) {
        return accountId.account_id.endsWith("00000000");
    }
    return false;
};

/** Swap the P/T env prefix of an account id (P<id> <-> T<id>). */
export const siblingAccountId = (accountId: string): string | undefined => {
    if (!/^[PT]/.test(accountId)) {
        return undefined;
    }
    return `${accountId[0] === "P" ? "T" : "P"}${accountId.substring(1)}`;
};

/**
 * Extract the `/:accountId` prefix from a pathname, or undefined when the first
 * segment is not an account id. Account ids are `P`/`T` followed by 3 or 8 digits.
 */
export const accountIdFromPath = (pathname: string): string | undefined => {
    const segment = pathname.split("/").filter(Boolean)[0];
    if (segment && /^[PT](\d{3}|\d{8})$/.test(segment)) {
        return segment;
    }
    return undefined;
};
